/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SubmitInputs */

const et_contact_submit = /** @type {(inputs: Contact_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saada päring`)
};

const en_contact_submit = /** @type {(inputs: Contact_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send inquiry`)
};

/**
* | output |
* | --- |
* | "Send inquiry" |
*
* @param {Contact_SubmitInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_submit = /** @type {((inputs?: Contact_SubmitInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SubmitInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_submit(inputs)
	return en_contact_submit(inputs)
});